import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import type {QueryClient} from "@tanstack/react-query";
import {
    parseWorkspaceDefinitionsMetadata,
    workspaceDefinitionsMetadataValidator,
    type WorkspaceDefinitionsMetadata,
} from "~/domainModels/adminModels/workspaceDefinitionMetadata";

export const WORKSPACE__DEFINITIONS__QUERY_KEY = "workspace-definitions";

export async function fetchWorkspaceDefinitionsMetadata({
    intellsysBaseUrl,
    accessToken,
}: {
    intellsysBaseUrl: string;
    accessToken: string;
}) {
    return robustJsonResultClientFetch(
        `${intellsysBaseUrl}/sub-system/pluto/admin/workspace-definitions/get`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({}),
        },
        workspaceDefinitionsMetadataValidator,
    );
}

export async function getWorkspaceDefinitionsMetadataWithCaching({
    queryClient,
    intellsysBaseUrl,
    accessToken,
}: {
    queryClient: QueryClient;
    intellsysBaseUrl: string;
    accessToken: string;
}): Promise<WorkspaceDefinitionsMetadata> {
    const result = await queryClient.ensureQueryData({
        queryKey: [WORKSPACE__DEFINITIONS__QUERY_KEY, "admin"],
        queryFn: async () => {
            const fetchResult = await fetchWorkspaceDefinitionsMetadata({intellsysBaseUrl, accessToken});
            if (fetchResult.success !== true) {
                throw fetchResult.error;
            }
            return parseWorkspaceDefinitionsMetadata(fetchResult.data);
        },
        retry: false,
        staleTime: Infinity,
    });
    return result;
}
